import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FomanticUIModule } from 'ngx-fomantic-ui';

import { HeaderContainerComponent } from './components/header-container/header-container.component';

@NgModule({
  declarations: [HeaderContainerComponent],
  imports: [CommonModule, RouterModule, FomanticUIModule],
  exports: [HeaderContainerComponent],
})
export class HeaderModule {}
